import {
  AccountClient,
  ApplicationsClient,
  AppSchemaClient,
  BeqClient,
  CalendarClient,
  ContactPhoneClient,
  CsClient,
  DrugsClient,
  EnrollmentsClient,
  GeoClient,
  OutboundContactClient,
  PharmacyClient,
  PlanCheckupClient,
  ProfilesClient,
  ProvidersClient,
  QuotingClient,
  RedirectClient,
  SessionClient,
  SiteClient
} from '~/generated/api-clients-generated'

export class PxApi {
  static use() {
    const { $$fetch } = FetchFactory.use()

    const http = () => ({
      fetch: (url: RequestInfo, options: any) => $$fetch().raw<any>(url, options)
    })

    const runtimeConfig = useRuntimeConfig()
    let baseUrl = runtimeConfig.public.pxApiBaseUrl

    if (process.server && baseUrl.includes('localhost')) {
      baseUrl = baseUrl.replace('localhost', '127.0.0.1')
    }

    const createAccountClient = () => new AccountClient(baseUrl, http())
    const createAppSchemaClient = () => new AppSchemaClient(baseUrl, http())
    const createDrugsClient = () => new DrugsClient(baseUrl, http())
    const createGeoClient = () => new GeoClient(baseUrl, http())
    const createPharmacyClient = () => new PharmacyClient(baseUrl, http())
    const createProfilesClient = () => new ProfilesClient(baseUrl, http())
    const createProvidersClient = () => new ProvidersClient(baseUrl, http())
    const createSessionClient = () => new SessionClient(baseUrl, http())
    const createSiteClient = () => new SiteClient(baseUrl, http())
    //const createImportClient = () => new ImportClient(baseUrl, http())
    const createApplicationsClient = () => new ApplicationsClient(baseUrl, http())
    const createBeqClient = () => new BeqClient(baseUrl, http())
    const createPlanCheckupClient = () => new PlanCheckupClient(baseUrl, http())
    const createCsClient = () => new CsClient(baseUrl, http())
    const createCalendarClient = () => new CalendarClient(baseUrl, http())
    const createOutboundContactClient = () => new OutboundContactClient(baseUrl, http())
    const createContactPhoneClient = () => new ContactPhoneClient(baseUrl, http())

    let engineBaseUrl = runtimeConfig.public.engineApiBaseUrl
    if (process.server && baseUrl.includes('localhost')) {
      engineBaseUrl = engineBaseUrl.replace('localhost', '127.0.0.1')
    }
    const createQuotingClient = () => new QuotingClient(engineBaseUrl, http())
    const createRedirectClient = () => new RedirectClient(engineBaseUrl, http())

    return {
      createAccountClient,
      createAppSchemaClient,
      createDrugsClient,
      createGeoClient,
      createPharmacyClient,
      createProfilesClient,
      createProvidersClient,
      createSessionClient,
      createSiteClient,
      createQuotingClient,
      createApplicationsClient,
      createBeqClient,
      createPlanCheckupClient,
      createCsClient,
      createCalendarClient,
      createOutboundContactClient,
      createContactPhoneClient,
      createRedirectClient
    }
  }
}
